module.exports = __webpack_public_path__ + "static/media/IMG_6400.a14f45c1.jpg";